import React, { useEffect } from "react";
import MainLayout from "../layout/MainLayout";
import Header from "../components/Header";
import { formatCurrency, months } from "../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { getTution } from "../redux/reducers/tuitionSlice";
import Loader from "../components/loader/loader";
import UnPaidCheckout from "./UnPaidCheckout";

const TuitionIncome = ({unPaid}) => {
  const dispatch = useDispatch();

  const { tuitionIncome ,loading } = useSelector((state) => state.tuition ?? []);
  const { userDetails } = useSelector((state) => state.auth);
  const { userId } = userDetails;

  useEffect(() => {
    // Fetch tuition data based on userId
    if (userId) {
      dispatch(getTution(userId));
    }
  }, [dispatch, userId]);


  useEffect(() => {
    // Fetch tuition data based on userId
    if (userId) {
      dispatch(getTution(userId));
    }
  }, []);




  const calculateTotal = (monthlyIncome) => {
    let total = 0;
    monthlyIncome.forEach((item) => {
      total += item.income;
    });
    return formatCurrency(total);
  };

  return (
    <MainLayout>
      <Loader loading={loading}/>
      
     {
      unPaid ?
      ( 
        <UnPaidCheckout/>
      )
      :
      (
        <>
        <Header
        title="Tuition Income Tracker"
        subTitle={`${tuitionIncome.length} Programs`}
        description="Track your Projected vs Actual Tuition Income here."
      />
    

      <div className="overflow-auto w-full space-y-8">
        {tuitionIncome?.map((program, idx) => (
          <div key={idx}>
            {/* Program Name */}
            <h2 className="text-lg font-bold text-gray-700 mb-4">
              {program?.programName}
            </h2>

            {/* Program Table */}
            <table className="min-w-full bg-white border border-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-bold text-gray-500 uppercase tracking-wider">
                    Year
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-bold text-gray-500 uppercase tracking-wider">
                    Type
                  </th>
                  {months.map((month, idx) => (
                    <th
                      key={idx}
                      className="px-6 py-3 text-left text-sm font-bold text-gray-500 uppercase tracking-wider"
                    >
                      {month}
                    </th>
                  ))}
                  <th className="px-6 py-3 text-left text-sm font-bold text-gray-500 uppercase tracking-wider">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Loop through incomeData to display Projected and Actual rows */}
                {program?.incomeData.map((incomeType, idx) => (
                  <tr key={idx}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b border-gray-200">
                      {incomeType?.year}
                    </td>
                    <td
                      className={`px-6 py-4 whitespace-nowrap text-sm border-b border-gray-200 ${
                        incomeType?.type === "Actual" ? "font-bold text-green-600" : "font-bold text-blue-600"
                      }`}
                    >
                      {incomeType?.type}
                    </td>
                    {months.map((month, idx) => {
                      const monthData = incomeType?.monthlyIncome.find(
                        (item) => item.month === month
                      );
                      return (
                        <td
                          key={idx}
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b border-gray-200"
                        >
                          {monthData ? formatCurrency(monthData?.income) : "-"}
                        </td>
                      );
                    })}
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b border-gray-200">
                      {calculateTotal(incomeType?.monthlyIncome)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
        </>
      )
     }
    </MainLayout>
  );
};

export default TuitionIncome;
